import React from 'react';
import { View, StyleSheet } from 'react-native';
import { TooltipDirections, TooltipVariants, TooltipSizes } from './constants';
import R from '../../core-res/R';
import DRNText from '../Text/DRNText';
import { withTheme } from '../../theme';
const TOOLTIP_ARROW_WIDTH = 12;
function getBackgroundColor(theme, variant) {
    if (variant === TooltipVariants.ALERT) {
        return R.color.uiRedDark;
    }
    // defaults to neutral
    return theme.darkPrimary;
}
function getTextColor(theme, variant) {
    if (variant === TooltipVariants.ALERT) {
        return R.color.uiLightPrimary;
    }
    // defaults to neutral
    return theme.lightPrimary;
}
function Arrow(props) {
    const { direction, backgroundColor, containerRect } = props;
    let arrowDirectionStyle;
    switch (direction) {
        case TooltipDirections.UP:
            arrowDirectionStyle = {
                top: -TOOLTIP_ARROW_WIDTH,
                left: containerRect.width / 2,
            };
            break;
        case TooltipDirections.LEFT:
            arrowDirectionStyle = {
                top: containerRect.height / 2,
                left: -TOOLTIP_ARROW_WIDTH,
                transform: [{ rotate: '-90deg' }],
            };
            break;
        case TooltipDirections.RIGHT:
            arrowDirectionStyle = {
                top: containerRect.height / 2,
                left: containerRect.width + TOOLTIP_ARROW_WIDTH,
                transform: [{ rotate: '90deg' }],
            };
            break;
        // default direction is down
        case TooltipDirections.DOWN:
        default:
            arrowDirectionStyle = {
                top: containerRect.height + TOOLTIP_ARROW_WIDTH,
                left: containerRect.width / 2,
                transform: [{ rotate: '180deg' }],
            };
            break;
    }
    return <View style={[styles.arrow, { borderBottomColor: backgroundColor }, arrowDirectionStyle]}/>;
}
class DRNTooltip extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            width: 0,
            height: 0,
        };
        this.containerRef = React.createRef();
        this.handleLayout = e => {
            const { width, height } = e.nativeEvent.layout;
            this.setState({ width: Math.floor(width), height: Math.floor(height) });
        };
    }
    render() {
        const { text, arrowDirection, variant, size, theme, style } = this.props;
        const backgroundColor = getBackgroundColor(theme, variant);
        const textColor = getTextColor(theme, variant);
        const containerRect = {
            width: this.state.width,
            height: this.state.height,
        };
        const textVariant = size === TooltipSizes.SMALL ? 'ui-small' : 'ui-baseline';
        return (<View style={styles.container}>
        <View style={[styles.tooltip, style, { backgroundColor }]} onLayout={this.handleLayout}>
          <DRNText style={{ color: textColor }} variant={textVariant}>
            {text}
          </DRNText>
        </View>
        <Arrow direction={arrowDirection} backgroundColor={backgroundColor} containerRect={containerRect}/>
      </View>);
    }
}
DRNTooltip.defaultProps = {
    arrowDirection: TooltipDirections.DOWN,
    variant: TooltipVariants.NEUTRAL,
    size: TooltipSizes.MEDIUM,
};
export default withTheme(DRNTooltip);
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        // padding for android positioning
        // https://github.com/facebook/react-native/issues/12534
        paddingVertical: TOOLTIP_ARROW_WIDTH,
        paddingHorizontal: TOOLTIP_ARROW_WIDTH,
    },
    tooltip: {
        zIndex: 1,
        paddingVertical: R.spacing.xs,
        paddingHorizontal: R.spacing.s,
        borderRadius: R.border.radius.default,
    },
    arrow: {
        position: 'absolute',
        borderStyle: 'solid',
        borderWidth: TOOLTIP_ARROW_WIDTH,
        borderColor: 'transparent',
        width: 0,
        height: 0,
        zIndex: 2,
    },
});
